export const FETCH_SCHEDULES = "FETCH_SCHEDULES";
export const DELETE_SCHEDULE = "DELETE_SCHEDULE";
export const ADD_SCHEDULE = "ADD_SCHEDULE";
export const UPDATE_SCHEDULE = "UPDATE_SCHEDULE";
export const CHANGE_STATUS_SCHEDULE = "CHANGE_STATUS_SCHEDULE";
export const CREATE_TIMESLOTS_FROM_SCHEDULE = "CREATE_TIMESLOTS_FROM_SCHEDULE";
export const SET_SELECTED_SCHEDULE = "SET_SELECTED_SCHEDULE";
export const UPDATE_DURATION_IN_SCHEDULE = "UPDATE_DURATION_IN_SCHEDULE";
